<template>
    <img class="topImgSty" :src="pictureLang[$i18n.locale]">
</template>
<script>
export default {
    data() {
        return {
            pictureLang: {
                en: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920997735114097900420678382.png",
                ja: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920999806795699408629990292.jpg",
                "zh-cn": "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914255085813804336165372819.png",
            }
        }
    },
}
</script>
<style></style>
 


// WEBPACK FOOTER //
// src/components/topPicJoin.vue